// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__3xFrb","AppMain":"App_AppMain__3Llhe","AppMenu":"App_AppMenu__2gkra","AppHeader":"App_AppHeader__GqCOk"};